export default __webpack_public_path__ + "static/media/core_illumination_bg.339989c3.jpg";